import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hmd-list-page__hd"
}
const _hoisted_2 = {
  key: 1,
  class: "hmd-list-page__bd"
}
const _hoisted_3 = {
  key: 2,
  class: "hmd-list-page__ft"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'hmd-list-page': true, 'has-header': _ctx.hasHeaderSlot, 'has-footer': _ctx.hasFooterSlot,'iframe-list':_ctx.isIframe })
  }, [
    (_ctx.hasHeaderSlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "header")
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasBodySlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "body")
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasFooterSlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}